import { NgModule } from '@angular/core';
import { GlbComponentsComponent } from './glb-components.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [GlbComponentsComponent, LoginFormComponent],
  imports: [
    FormsModule
  ],
  exports: [GlbComponentsComponent, LoginFormComponent]
})
export class GlbComponentsModule { }
